// Text color constants for banners and UI elements
export const TEXT_COLORS = {
  // Banner colors
  BANNER_NEW: '#fadb14',        // Yellow for "new" banners (new stack, new twisted stack)
  BANNER_RESPONSES: '#28a745',  // Green for "new responses" banners
  BANNER_COMMENTS: '#fd7e14',   // Orange for "new comments" banners
  BANNER_DRAFT: '#007bff',      // Blue for "draft" banners
  BANNER_COLLAB: '#e91e63',     // Dark pink/fuschia for "collab" banners
  
  // Button text colors
  BUTTON_WHITE: 'white',        // White text for buttons
  BUTTON_BLACK: 'black',        // Black text for buttons
  
  // Standard text colors
  PRIMARY: '#333',              // Primary text color (headings, important text)
  SECONDARY: '#666',            // Secondary text color (descriptions, labels)
  MUTED: '#999',                // Muted text color (subtle text)
  
  // Status colors
  SUCCESS: '#4caf50',           // Green for success states
  ERROR: '#f44336',             // Red for error states
  WARNING: '#ff9800',           // Orange for warning states
  INFO: '#2196f3',              // Blue for info states
};
